export default "__VITE_ASSET__CH3IajX5__"